import i from "./index.es43.js";
function a(t, o) {
  const p = {
    status: o ? "draft" : "published",
    filters: {
      slug: {
        $eq: t
      }
    },
    populate: {
      introduction: {
        populate: "*"
      },
      richtextSections: {
        populate: "*"
      },
      sections: {
        populate: {
          section: {
            populate: {
              components: {
                on: {
                  "statistics.info-block": {
                    populate: {
                      tooltips: "*"
                    }
                  },
                  "statistics.statistics-block": {
                    populate: {
                      block: {
                        populate: {
                          explanation: {
                            populate: {
                              tooltips: "*"
                            }
                          },
                          description: {
                            populate: {
                              tooltips: "*"
                            }
                          },
                          file: {
                            populate: "*"
                          }
                        }
                      }
                    }
                  },
                  "statistics.accordions-block": {
                    populate: {
                      accordions: {
                        populate: ["tooltips"]
                      }
                    }
                  }
                }
              },
              introduction: {
                populate: {
                  tooltips: "*"
                }
              }
            }
          }
        }
      },
      mainPoints: {
        on: {
          "statistics.donut-point": {
            populate: "*"
          },
          "statistics.number-in-ten-point": {
            populate: "*"
          }
        }
      }
    }
  };
  return i.stringify(p);
}
export {
  a as default
};
//# sourceMappingURL=index.es8.js.map
